import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-default-icon',
  templateUrl: './default-icon.component.html',
  styleUrls: ['./default-icon.component.scss']
})
export class DefaultIconComponent implements OnInit {

  @Input() name: string = 'U';
  @Input() figureClass: string = '';

  constructor() { }

  ngOnInit() {
  	this.name = this.name[0];
  }

}
